export class ValidationError extends Error {
  constructor() {
    super("校验参数错误")
  }
}
